export const PROFILE_COMPLETION_DEADLINE = "2026-09-07";

export const PROFILE_DECLARATION_TEXT =
  "أتعهد وأقر بأن جميع البيانات المدخلة أعلاه صحيحة ومحدثة بالكامل وعلى مسؤوليتي الشخصية، وفي حالة تبين عدم صحة أي من هذه البيانات أو تقديم بيانات غير دقيقة أو مزيفة، فإنني أعرض نفسي للمسائلة القانونية والإدارية والتي قد تصل إلى إنهاء الخدمة/الفصل وفقاً للوائح العمل المنظمة.";

export const PROFILE_UPDATED_EVENT = "profile:updated";

const CAIRO_TZ = "Africa/Cairo";
const DAY_MS = 86_400_000;
const MONTHS_AR = [
  "يناير",
  "فبراير",
  "مارس",
  "أبريل",
  "مايو",
  "يونيو",
  "يوليو",
  "أغسطس",
  "سبتمبر",
  "أكتوبر",
  "نوفمبر",
  "ديسمبر",
];

export function cairoDateYmd(instant = new Date()) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: CAIRO_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(instant);
}

export function formatProfileDeadlineAr(ymd = PROFILE_COMPLETION_DEADLINE) {
  const [year, month, day] = String(ymd).split("-").map(Number);
  if (!year || !month || !day) return ymd;
  return `${day} ${MONTHS_AR[month - 1]} ${year}`;
}

export function daysRemainingUntilProfileDeadline(now = new Date()) {
  const todayMs = Date.parse(`${cairoDateYmd(now)}T00:00:00.000Z`);
  const deadlineMs = Date.parse(`${PROFILE_COMPLETION_DEADLINE}T00:00:00.000Z`);
  return Math.round((deadlineMs - todayMs) / DAY_MS);
}

export function areProfileFieldsComplete(profileCompleteness) {
  const fields = profileCompleteness?.sections?.fields;
  if (Array.isArray(fields) && fields.length > 0) {
    return fields.every((item) => item.filled);
  }
  if (typeof profileCompleteness?.fieldsComplete === "boolean") {
    return profileCompleteness.fieldsComplete;
  }
  return false;
}

export function resolveProfileCompletionState(employee, now = new Date()) {
  const fromApi = employee?.profileCompletion;
  if (fromApi && typeof fromApi.isLocked === "boolean") {
    return {
      deadline: fromApi.deadline || PROFILE_COMPLETION_DEADLINE,
      deadlinePassed: Boolean(fromApi.deadlinePassed),
      daysRemaining: Number(fromApi.daysRemaining) || 0,
      fieldsComplete: Boolean(fromApi.fieldsComplete),
      completionRequired:
        typeof fromApi.completionRequired === "boolean"
          ? fromApi.completionRequired
          : true,
      isLocked: Boolean(fromApi.isLocked),
      declarationAcceptedAt: fromApi.declarationAcceptedAt || null,
    };
  }

  const daysRemaining = daysRemainingUntilProfileDeadline(now);
  const deadlinePassed = daysRemaining < 0;
  const fieldsComplete = areProfileFieldsComplete(employee?.profileCompleteness);
  return {
    deadline: PROFILE_COMPLETION_DEADLINE,
    deadlinePassed,
    daysRemaining: Math.max(0, daysRemaining),
    fieldsComplete,
    completionRequired: true,
    isLocked: deadlinePassed && !fieldsComplete,
    declarationAcceptedAt: employee?.profileDeclarationAcceptedAt || null,
  };
}

export function profileCompletionBannerText(state) {
  if (state?.completionRequired === false) {
    return "";
  }
  const deadlineLabel = formatProfileDeadlineAr(state?.deadline);
  if (state?.isLocked) {
    return `انتهت مهلة استكمال البيانات (${deadlineLabel}). أكمل جميع البيانات المطلوبة ووافق على الإقرار حتى يُفتح باقي الحساب.`;
  }
  if (state?.fieldsComplete) {
    return "";
  }
  if (state?.daysRemaining === 0) {
    return `اليوم آخر موعد لاستكمال بياناتك الشخصية (${deadlineLabel}). بعد اليوم لن يفتح الحساب إلا على الملف الشخصي.`;
  }
  return `استكمال البيانات الشخصية إجباري. أمامك ${formatRemainingDaysAr(
    state?.daysRemaining,
  )} حتى ${deadlineLabel}، وبعدها لن يفتح الحساب إلا على الملف الشخصي.`;
}

function formatRemainingDaysAr(days) {
  const n = Number(days) || 0;
  if (n === 1) return "يوم واحد";
  if (n === 2) return "يومان";
  if (n >= 3 && n <= 10) return `${n} أيام`;
  return `${n} يومًا`;
}
